module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularVietWeb-Black.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularVietWeb-Black.eot
 ** module id = 340
 ** module chunks = 0
 **/